import firebase from "firebase";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCYzx3fAIx-p268o66oGxhlwvOO3TTqP8I",
  authDomain: "clone-80344.firebaseapp.com",
  databaseURL: "https://clone-80344.firebaseio.com",
  projectId: "clone-80344",
  storageBucket: "clone-80344.appspot.com",
  messagingSenderId: "498145424472",
  appId: "1:498145424472:web:38c599bf86825f853f862d",
  measurementId: "G-DGV8G9E1HY"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore(); //gives database
const auth = firebase.auth(); // gives a variable (auth) for sig in etc...

export { db,auth };